import React, { useContext } from 'react';
import DetailedProgressSummary from '@/components/pages/assessments/common/DetailedProgressSummary';
import StepCounter from '@/components/pages/assessments/common/StepCounter';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function AssessmentQuestion({ question = null, page = null }) {
  const { xt } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const { step, total, sequence, metadata } = useContext(stepContext);
  const introCount = sequence?.filter((s) => s.type === 'intro').length || 0;

  const options = metadata?.options;
  const displayStep = options?.skip_intro ? step + 1 : step;
  const displayTotal = total - introCount;
  let config = null;
  let label = '';

  if (question) {
    const q = question.question;
    config = (metadata?.profile_questions || []).find((p) => p.id === q.id);
    label = xt(config?.label) || q.public_label || q.label;
  } else {
    config = (metadata?.pages || []).find((p) => p.id === page.id);
    label = xt(config?.label) || '';
  }

  const jsx = () => {
    switch (config?.layout || options?.layout) {
      case 'detailed_progress':
        return <DetailedProgressSummary totalSteps={displayTotal} currentStep={displayStep} title={label} detailedContent={config?.details} />;
      case 'basic':
      default:
        return (
          <Row>
            <Col className={`${css('assessment-column-padding')} ${css('assessment-question-container')}`}>
              <div className={css('assessment-progress-container')}>
                <StepCounter step={displayStep} total={displayTotal} />
                <StepCounter step={displayStep} total={displayTotal} type="progress" />
              </div>
              <h1 className={css('assessment-question-label')}>{label}</h1>
            </Col>
          </Row>
        );
    }
  };

  return <div className={`${css('assessment-question')}`}>{jsx()}</div>;
}

export default AssessmentQuestion;
